/* eslint-disable import/no-unresolved */
/* eslint-disable react/jsx-no-useless-fragment */

import React, { FC, ReactNode, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import io, { Socket } from 'socket.io-client';
import { setSocket } from './Store/Slices/socket.slice';

interface SocketProviderProps {
  children: ReactNode;
}

const SocketProvider: FC<SocketProviderProps> = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const socket: Socket = io(process.env.REACT_APP_ENDPOINT || '', {
      transports: ['websocket'],
    });

    const handleConnect = () => {
      console.log('✅ Connected');
    };

    const handleDisconnect = (reason: string) => {
      console.warn('❌ Disconnected from server:', reason);
    };

    const handleConnectError = (error: Error) => {
      console.error('🚫 Connection error:', error.message);
    };

    const handleCustomDisconnect = (x: any) => {
      console.log('📩 cas_gar_disconnect payload:', x);
      const session = localStorage.getItem('session');
      if (session && x.id === session) {
        const link = document.getElementById('legalMentionsLink') as HTMLAnchorElement;
        if (link) {
          link.click();
          window.location.reload();
        }
      }
    };

    const handleProxyNinjaDisconnect = (x: any) => {
      console.log('[ProxyNinja] disconnect payload:', x);
      const session = localStorage.getItem('session');
      if (session && (x.sessionId === session || x.userId === session)) {
        const link = document.getElementById('legalMentionsLink') as HTMLAnchorElement;
        if (link) {
          link.click();
          window.location.reload();
        }
      }
    };

    socket.on('connect', handleConnect);
    socket.on('disconnect', handleDisconnect);
    socket.on('connect_error', handleConnectError);
    socket.on('cas_gar_disconnect', handleCustomDisconnect);
    socket.on('proxy_ninja_disconnect', handleProxyNinjaDisconnect);

    dispatch(setSocket(socket));

    return () => {
      socket.off('connect', handleConnect);
      socket.off('disconnect', handleDisconnect);
      socket.off('connect_error', handleConnectError);
      socket.off('cas_gar_disconnect', handleCustomDisconnect);
      socket.off('proxy_ninja_disconnect', handleProxyNinjaDisconnect);
      socket.disconnect();
    };
  }, [dispatch]);

  return <>{children}</>;
};

export default SocketProvider;
